import React from 'react';
import styled from 'styled-components';

import { translate } from 'translations/i18n';

// #region styled-components
const Container = styled.div`
  display: flex;
  margin-bottom: 12px;
`;
const Badge = styled.div`
  padding: 0 var(--cc_size_spacing_s) 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: var(--cc_size_avatar_s);
  border: 1px solid var(--cc_color_utility_caution);
  background-color: var(--cc_color_utility_caution_alpha_20);
  border-radius: 3px;
  width: auto;
`;

const TextContent = styled.p`
  font-weight: bold;
  font-size: var(--cc_size_text_xs);
  color: var(--cc_color_text_subtle);
  text-transform: uppercase;
  margin: 0;
  line-height: 1;
`;
// #endregion

const TemplateBeingEditedLabel = () => {
  return (
    <Container>
      <Badge>
        <TextContent>
          {translate('projects.taskList.template.beingEditedStatus')}
        </TextContent>
      </Badge>
    </Container>
  );
};

export default TemplateBeingEditedLabel;
